<body>
  <div class="grid-overlay">
    <app-page-header>
      <img src="../../assets/icons/user.png" alt="icono usuario" style="width:50px; height:50px;">
      <h4 class="header-username">{{ username }}</h4>
    </app-page-header>
    <div class="editing-preferences">
      <form [formGroup]="form" >
        <h1>{{ 'preferences.title' | translate }}</h1>
        <div class="change-of-password">
          <h1>{{ 'preferences.changePassword' | translate }}</h1>
          <div class="grid">
            <div class="left">
              <div class="items">
                <label for="current-password">{{ 'preferences.currentPassword' | translate }}</label>
                <div class="password-input-wrapper">
                  <input
                    autocomplete="actual_password"
                    [formControl]="form.controls['actual_password']"
                    [type]="showActualPassword ? 'text' : 'password'"
                    class="password-input"
                    >
                    <button type="button"
                      (click)="toggleActualPassword()"
                      class="toggle-password-btn"
                      tabindex="-1"
                      aria-label="Mostrar/ocultar contraseña actual">
                      <img [src]="showActualPassword ? 'assets/icons/ver.png' : 'assets/icons/ver.png'" alt="Toggle visibility" class="toggle-password-img">
                    </button>
                  </div>
                  @if (form.controls['actual_password'].hasError('required') && form.controls['actual_password'].touched) {
                    <small class="form-error-msg"> {{ 'preferences.currentPasswordRequired' | translate }} </small>
                  }
                </div>
                <div class="items">
                  <label for="new-password">{{ 'preferences.newPassword' | translate }}</label>
                  <div class="password-input-wrapper">
                    <input
                      autocomplete="new_password"
                      [formControl]="form.controls['new_password']"
                      [type]="showNewPassword ? 'text' : 'password'"
                      class="password-input"
                      >
                      <button type="button"
                        (click)="toggleNewPassword()"
                        class="toggle-password-btn"
                        tabindex="-1"
                        aria-label="Mostrar/ocultar nueva contraseña">
                        <img [src]="showNewPassword ? 'assets/icons/ver.png' : 'assets/icons/ver.png'" alt="Toggle visibility" class="toggle-password-img">
                      </button>
                    </div>
                    @if (form.controls['new_password'].hasError('required') && form.controls['new_password'].touched) {
                      <small class="form-error-msg"> {{ 'preferences.newPasswordRequired' | translate }} </small>
                    }
                  </div>
                  <div class="items">
                    <label for="repit-password">{{ 'preferences.repeatPassword' | translate }}</label>
                    <div class="password-input-wrapper">
                      <input
                        autocomplete="newPasswordConfirm"
                        [formControl]="form.controls['newPasswordConfirm']"
                        [type]="showNewPasswordConfirm ? 'text' : 'password'"
                        class="password-input"
                        >
                        <button type="button"
                          (click)="toggleNewPasswordConfirm()"
                          class="toggle-password-btn"
                          tabindex="-1"
                          aria-label="Mostrar/ocultar repetir contraseña">
                          <img [src]="showNewPasswordConfirm ? 'assets/icons/ver.png' : 'assets/icons/ver.png'" alt="Toggle visibility" class="toggle-password-img">
                        </button>
                      </div>
                      @if (form.controls['newPasswordConfirm'].hasError('required') && form.controls['newPasswordConfirm'].touched) {
                        <small  class="form-error-msg"> {{ 'preferences.fieldRequired' | translate }} </small>
                      }
                      @if (form.controls['newPasswordConfirm'].invalid && (form.controls['newPasswordConfirm'].dirty || form.controls['newPasswordConfirm'].touched)) {
                        <small>
                        {{ 'preferences.passwordsMustMatch' | translate }}</small>
                      }
                    </div>
                  </div>
                  <div class="right">
                    <p>{{ 'preferences.recommendations' | translate }}</p>
                    <div class="recommendations">
                      <p [class.valid]="getPasswordErrors() === null || getPasswordErrors()?.hasMinLength"
                        [class.invalid]="getPasswordErrors()?.hasMinLength === false">
                        @if (getPasswordErrors() === null || getPasswordErrors()?.hasMinLength) {
                          <span class="status-icon">✓</span>
                        }
                        @if (getPasswordErrors()?.hasMinLength === false) {
                          <span class="status-icon invalid-icon">✗</span>
                        }
                        {{ 'preferences.minLength' | translate }}
                      </p>
                      <p [class.valid]="getPasswordErrors() === null || getPasswordErrors()?.hasUpperCase"
                        [class.invalid]="getPasswordErrors()?.hasUpperCase === false">
                        @if (getPasswordErrors() === null || getPasswordErrors()?.hasUpperCase) {
                          <span class="status-icon">✓</span>
                        }
                        @if (getPasswordErrors()?.hasUpperCase === false) {
                          <span class="status-icon invalid-icon">✗</span>
                        }
                        {{ 'preferences.upperCase' | translate }}
                      </p>
                      <p [class.valid]="getPasswordErrors() === null || getPasswordErrors()?.hasLowerCase"
                        [class.invalid]="getPasswordErrors()?.hasLowerCase === false">
                        @if (getPasswordErrors() === null || getPasswordErrors()?.hasLowerCase) {
                          <span class="status-icon">✓</span>
                        }
                        @if (getPasswordErrors()?.hasLowerCase === false) {
                          <span class="status-icon invalid-icon">✗</span>
                        }
                        {{ 'preferences.lowerCase' | translate }}
                      </p>
                      <p [class.valid]="getPasswordErrors() === null || getPasswordErrors()?.hasNumber"
                        [class.invalid]="getPasswordErrors()?.hasNumber === false">
                        @if (getPasswordErrors() === null || getPasswordErrors()?.hasNumber) {
                          <span class="status-icon">✓</span>
                        }
                        @if (getPasswordErrors()?.hasNumber === false) {
                          <span class="status-icon invalid-icon">✗</span>
                        }
                        {{ 'preferences.number' | translate }}
                      </p>
                      <p [class.valid]="getPasswordErrors() === null || getPasswordErrors()?.hasSpecialChar"
                        [class.invalid]="getPasswordErrors()?.hasSpecialChar === false">
                        @if (getPasswordErrors() === null || getPasswordErrors()?.hasSpecialChar) {
                          <span class="status-icon">✓</span>
                        }
                        @if (getPasswordErrors()?.hasSpecialChar === false) {
                          <span class="status-icon invalid-icon">✗</span>
                        }
                        {{ 'preferences.specialChar' | translate }}
                      </p>
                    </div>
                    <button type="button" (click)="generatePassword()" class="generate-password-btn">
                      {{ 'preferences.generate' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="buttons">
            <button (click)="goBack()" >{{ 'preferences.back' | translate }}</button>
            <div class="action-buttons">
              <!-- <button class="edit-btn">Editar</button> -->
              <button (click)="send()">{{ 'preferences.save' | translate }}</button>
            </div>
          </div>
        </div>
      </body>
